import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Card, CardBody, Container, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { VHU_LOTS_PAGE } from "../../routes/routeConstants";
import { deleteEnchere, loadExpiredEncheres } from "../encheres/enchereService";
const dateLabel = (value) => value ? new Intl.DateTimeFormat("fr-FR", { dateStyle: "medium", timeStyle: "short" }).format(new Date(value)) : "-";

function VhuExpiredLotsPage() {
  const navigate = useNavigate();
  const [lots, setLots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [notice, setNotice] = useState(null);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await loadExpiredEncheres();
      setLots(response?.data?.body || []);
    } catch (error) {
      setNotice({ color: "danger", message: error?.response?.data?.message || "Impossible de charger les enchères expirées." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      await deleteEnchere(deleteTarget.id);
      setDeleteTarget(null);
      setNotice({ color: "success", message: "L'enchère expirée a été supprimée." });
      await loadData();
    } catch (error) {
      setNotice({ color: "danger", message: error?.response?.data?.message || "Impossible de supprimer cette enchère." });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="page-content auction-page vhu-lots-page">
      <Container fluid>
        <Breadcrumbs
          title="Enchères expirées"
          breadcrumbItems={[{ title: "Lots VHU", link: VHU_LOTS_PAGE }, { title: "Expirées", link: "#" }]}
          actions={<Button color="light" onClick={() => navigate(VHU_LOTS_PAGE)}><i className="ri-arrow-left-line me-1" />Lots actifs</Button>}
        />

        {notice && <Alert color={notice.color} toggle={() => setNotice(null)}>{notice.message}</Alert>}

        {loading ? (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        ) : !lots.length ? (
          <div className="vhu-empty-state"><i className="ri-time-line" /><strong>Aucune enchère expirée</strong></div>
        ) : (
          <div className="vhu-lot-grid">
            {lots.map((lot) => (
              <Card className="h-100 auction-card vhu-lot-card" key={lot.id}>
                <CardBody>
                  <div className="d-flex justify-content-between gap-2 mb-3">
                    <div className="min-w-0">
                      <h6 className="mb-1 text-truncate" title={lot.titre}>{lot.titre || `Lot #${lot.id}`}</h6>
                      <div className="text-muted small">{lot.vehiculeLabel || `Enchère #${lot.id}`}</div>
                    </div>
                    <Badge color="dark">Clôturée</Badge>
                  </div>
                  <div className="mb-3"><span className="text-muted small d-block">Date de fin</span><strong>{dateLabel(lot.dateFin)}</strong></div>
                  <div className="small text-muted mb-3">
                    Ciblage : {lot.ciblage || "-"} · Prix de départ : {Number(lot.prixDepart || 0).toLocaleString("fr-FR")} MAD
                  </div>
                  <Button color="danger" outline size="sm" onClick={() => setDeleteTarget(lot)}>
                    <i className="ri-delete-bin-line me-1" />Supprimer
                  </Button>
                </CardBody>
              </Card>
            ))}
          </div>
        )}
      </Container>

      <Modal isOpen={Boolean(deleteTarget)} toggle={() => !deleting && setDeleteTarget(null)} backdrop="static">
        <ModalHeader toggle={() => !deleting && setDeleteTarget(null)}>Supprimer définitivement</ModalHeader>
        <ModalBody>Voulez-vous supprimer l'enchère « {deleteTarget?.titre || deleteTarget?.reference} » et ses données associées ?</ModalBody>
        <ModalFooter>
          <Button color="light" disabled={deleting} onClick={() => setDeleteTarget(null)}>Annuler</Button>
          <Button color="danger" disabled={deleting} onClick={confirmDelete}>{deleting && <Spinner size="sm" className="me-2" />}Supprimer</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default VhuExpiredLotsPage;
